import * as React from 'react'
import * as ReactDOM from 'react-dom'

class DonateRecent extends React.Component {
    constructor(props) {
        super(props)
        
        let {quote_sub_title,quote_content,quote_content_footer} = props.data;
        this.state = {
            quote_sub_title : quote_sub_title,
            quote_content:quote_content,
            quote_content_footer:quote_content_footer,
        };
    }
    render() {
        return (
                <div className="quote-content__container">
                    <div className="quote-content--title">
                        <p className="ecf-title-mini-box">
                            {this.state.quote_sub_title}
                        </p>
                    </div>
                    <div className="quote-content--text mb-32 mb-lg-3"  dangerouslySetInnerHTML={{
                        __html: this.state.quote_content,
                    }}>
                    </div>
                    <div className="quote-content--last text-end" dangerouslySetInnerHTML={{
                        __html: this.state.quote_content_footer,
                    }}>
                    </div>
                </div>
        );
    }
}

export default DonateRecent;